"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var lodash_1 = require("lodash");
var operators_1 = require("rxjs/operators");
function simpleDebug(logger, message) {
    return operators_1.tap(function (data) { return logger.debug(message, data); });
}
exports.simpleDebug = simpleDebug;
function round(num, fractionDigits) {
    if (lodash_1.isNil(num)) {
        return num;
    }
    return (Math.round(num * Math.pow(10, fractionDigits)) /
        Math.pow(10, fractionDigits));
}
exports.round = round;
function todayUTC() {
    var today = new Date();
    return new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()));
}
exports.todayUTC = todayUTC;
function createLogger(scope) {
    return new skynet_store_utilities_1.Logger('idm-currency-rate-frontend', scope);
}
exports.createLogger = createLogger;
//# sourceMappingURL=utilities.js.map